<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="paieskaTipasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Paieškos pavadinimas"
                  tooltip="Paieška. Mano paieškos. Paieškos pavadinimas"
                  v-model="extraData.pai_tipas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Paieškos numeris"
                  tooltip="Paieška. Mano paieškos. Paieškos numeris"
                  v-model="extraData.pai_numeris"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="paieskaBusenaList"
                  itemvalue="value"
                  itemtext="text"
                  label="Paieškos būsena"
                  tooltip="Paieška. Mano paieškos. Paieškos būsena"
                  v-model="extraData.pai_busena"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Paieškos data nuo"
                  tooltip="Paieška. Mano paieškos. Paieškos data nuo"
                  v-model="extraData.pai_sukurimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Paieškos data iki"
                  tooltip="Paieška. Mano paieškos. Paieškos data iki"
                  v-model="extraData.pai_sukurimo_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  primary
                  :loading="loading"
                  @click.native.stop="searchData()"
                >
                  Ieškoti
                </el-button>
                <el-button :loading="loading" @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaieskaManoSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      pai_tipas: null,
      pai_numeris: null,
      pai_busena: null,
      pai_sukurimo_data_nuo: null,
      pai_sukurimo_data_iki: null,
    },
  }),
  computed: {
    ...mapGetters(['searchParams', 'appSavitarna', 'savitarnaXid']),
    isExpanded() {
      return this.searchPanel === 0
    },
    paieskaTipasList() {
      return [
        { value: 'juridinis', text: 'Pagal juridinį asmenį' },
        { value: 'fizinis', text: 'Pagal fizinį asmenį' },
        { value: 'turtas', text: 'Pagal turtą' },
        { value: 'kodas', text: 'Pagal identifikavimo kodą' },
      ]
    },
    paieskaBusenaList() {
      return this.isSavitarna
        ? [
            { value: 'laukia_patvirtinimo', text: 'Laukia patvirtinimo' },
            { value: 'tikrinama', text: 'Tikrinama' },
            { value: 'laukia_apmokejimo', text: 'Laukia apmokėjimo' },
            { value: 'vykdoma', text: 'Vykdoma' },
            { value: 'ivykdyta', text: 'Įvykdyta' },
            { value: 'neivykdyta', text: 'Neįvykdyta' },
            { value: 'atmesta', text: 'Atmesta' },
          ]
        : [
            { value: 'vykdoma', text: 'Vykdoma' },
            { value: 'ivykdyta', text: 'Įvykdyta' },
            { value: 'neivykdyta', text: 'Neįvykdyta' },
          ]
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    if (
      this.searchParams &&
      this.searchParams.route === this.$route.name &&
      this.searchParams.xid === this.savitarnaXid
    ) {
      this.mainData = this.searchParams.mainData
      this.extraData = this.searchParams.extraData
      this.searchPanel = this.searchParams.isExpanded ? 0 : null
    }
    this.searchData()
  },
  methods: {
    searchData() {
      let searchData = {
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        xid: this.savitarnaXid,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.extraData = {
        pai_tipas: null,
        pai_numeris: null,
        pai_busena: null,
        pai_sukurimo_data_nuo: null,
        pai_sukurimo_data_iki: null,
      }
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
